// 导入axios
import axios from "axios";
import router from "@/router";
import { Toast } from "vant";
/**
 * 提示函数
 * 禁止点击蒙层、显示一秒后关闭
 */
const tip = (msg) => {
  Toast({
    message: msg,
    duration: 1000,
    forbidClick: true,
  });
}
/**
 * 跳转登录页
 * 携带当前页面路由，以期在登录页面完成登录后返回当前页面
 */
const toLogin = () => {
  router.replace({
    path: "/login",
    query: {
      redirect: router.currentRoute.fullPath,
    },
  });
};
/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status, other) => {
  // 状态码判断
  switch (status) {
    // 401: 未登录状态，跳转登录页
    case 401:
      localStorage.removeItem("token");
      toLogin();
      break;
    // 403 token过期
    // 清除token并跳转登录页
    case 403:
      tip("登录过期，请重新登录");
      localStorage.removeItem("token");
      // store.commit('loginSuccess', null);
      setTimeout(() => {
        toLogin();
      }, 1000);
      break;
    // 404请求不存在
    case 404:
      tip("请求的资源不存在");
      break;
    default:
      console.log(other);
  }
};
// 使用自定义配置新建一个axios 实例，对axios 做一些基础配置
const instance = axios.create({
  //baseURL: "https://zhenpin.zhujiaxian.com/",
  baseURL: "https://zhenpin.zhujiaxian.com/", 
 //baseURL: 'http://192.168.0.16:8107',
  timeout: 5000,
  headers: { "X-Custom-Header": "foobar" },
});

// 添加请求拦截器
instance.interceptors.request.use(
  function (config) {
    //请求之前执行该函数， 一般在该处设置token
    //console.log(config);
    // if(){

    // }
    let token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = token;
    }
    // 在发送请求之前做些什么
    return config;
  },
  function (error) {
    console.log(error, "error");
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);
// 响应拦截器
instance.interceptors.response.use(
  // 请求成功
  (res) => (res.status === 200 ? Promise.resolve(res) : Promise.reject(res)),
  // 请求失败
  (error) => {
    const { response } = error;
    if (response) {
      // 请求已发出，但是不在2xx的范围
      errorHandle(response.status, response.data.message);
      return Promise.reject(response);
    } else {
      // 处理断网的情况
      // eg:请求超时或断网时，更新state的network状态
      // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
      // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
      if (!window.navigator.onLine) {
        //store.commit('changeNetwork', false);
      } else {
        return Promise.reject(error);
      }
    }
  }
);
//响应拦截器
// instance.interceptors.response.use(response => {
//   //1.非200响应
//   //2.token过期
//   //3.异地登陆
//   //4.非对象加密的解密
//   return response.data
// })
export default instance;
